export const chargeTypeMap = {
  cash: 'self_pay',
  copay: 'primary'
};

export const productFields = [
  'id',
  'name',
  'amount_cents_with_tax',
  'quantity',
  'total_amount_cents',
  'sales_count',
  'state_tax_rate',
  'local_tax_rate'
];

export const serviceFields = [
  'id',
  'name',
  'time_length',
  'charge_type',
  'procedure_code',
  'total_cost_cents',
  'state_tax_rate',
  'local_tax_rate'
];

export const defaultFields = [
  'id',
  'name',
  'note',
  'image',
  'products',
  'procedures',
  'sales_count',
  'amount_cents',
  'no_expiration',
  'total_amount_cents',
  'validity_time_unit',
  'validity_time_length',
  'state_tax_rate',
  'local_tax_rate'
];
